export const supportNetwork = { 
    1 : {
        name : "Mainnet",
        chainId : 1,
        rpc : "https://mainnet.infura.io/v3/8d729339efb248de9141bce45903ff7c",
        symbol : 'ETH'
    }
}

export const RPC_URLS = {
   1 : "https://mainnet.infura.io/v3/8d729339efb248de9141bce45903ff7c"
};